import React, { useState } from 'react';

import { scale as initialScale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import ColorsWrapper from '@styles/colors';
import { isWeb } from '@helpers';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

const WebImageControls = ({
  C,
  pressImage,
  rotateImage,
  openImage,
  cropImage,
  documentId,
  scale = initialScale,
}: {
  C: ColorFunction;
  pressImage: () => void;
  rotateImage: () => void;
  openImage: () => void;
  cropImage?: () => void;
  documentId: number;
  scale?: ScaleFunction;
}) => {
  const [isImageHovered, setIsImageHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsImageHovered(true)}
      onMouseLeave={() => setIsImageHovered(false)}
      onClick={pressImage}
      style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10, cursor: 'pointer' }}
    >
      <TouchableElement onPress={rotateImage}>
        {({ pressHoverColor }) => (
          <div
            style={{
              backgroundColor: C(pressHoverColor('Button/Light/PrimaryMono')),
              position: 'absolute',
              zIndex: 20,
              left: scale(6),
              top: scale(6),
              opacity: isImageHovered ? 1 : 0,
              cursor: 'pointer',
              padding: scale(7),
              borderRadius: scale(18),
            }}
          >
            <Svg icon="rotate" width={scale(18)} height={scale(18)} color="Label/Light/Inverted" />
          </div>
        )}
      </TouchableElement>
      {cropImage && (
        <TouchableElement onPress={cropImage}>
          {({ pressHoverColor }) => (
            <div
              style={{
                backgroundColor: C(pressHoverColor('Button/Light/PrimaryMono')),
                position: 'absolute',
                zIndex: 20,
                left: scale(6),
                top: scale(42), // Position below rotate button
                opacity: isImageHovered ? 1 : 0,
                cursor: 'pointer',
                padding: scale(7),
                borderRadius: scale(18),
              }}
            >
              <Svg icon="crop" width={scale(18)} height={scale(18)} color="Label/Light/Inverted" />
            </div>
          )}
        </TouchableElement>
      )}
      <TouchableElement
        onPress={(e) => {
          if (isWeb) {
            if (!e.ctrlKey && !e.metaKey) {
              e.preventDefault();
              openImage();
            }
          } else {
            openImage();
          }
        }}
        href={`/image-handling?documentId=${documentId}`}
        useOpacity={true}
      >
        {({ pressHoverColor }) => (
          <div
            style={{
              backgroundColor: C(pressHoverColor('Button/Light/PrimaryMono')),
              position: 'absolute',
              zIndex: 20,
              right: scale(6),
              top: scale(6),
              opacity: isImageHovered ? 1 : 0,
              cursor: 'pointer',
              padding: scale(7),
              borderRadius: scale(18),
            }}
          >
            <Svg icon="expandView" width={scale(18)} height={scale(18)} color="Label/Light/Inverted" />
          </div>
        )}
      </TouchableElement>
    </div>
  );
};

export default ColorsWrapper(WebImageControls);
